import React from 'react';
import { useLocation } from 'react-router-dom';
import Footer from './Footer';

const FooterWrapper = () => {
    const location = useLocation();
    const isHome = location.pathname === '/';

    return <Footer isHome={isHome} />;
};

export default FooterWrapper;
